import {useNavigate} from 'react-router-dom';
import {RespiratorySymptomsBase} from './base';
import {CheckedConfirmation} from '../../components/confirmationMessages/checkedConfirmation';

/**
 * React functional component representing Checked Confirmation Page.
 * @component
 * @returns {JSX.Element} The rendered CheckedConfirmationPage1 component.
 */
export const CheckedConfirmationPage1 = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleNext = async () => {
    sessionStorage.removeItem('cough-value');
    navigate('/results');
  };

  return (
    <RespiratorySymptomsBase
      pageNumber={1}
      handleBack={() => handleBack()}
      handleNext={() => handleNext()}
      backButtonName={'Back'}
      nextButtonName={'Next'}
    >
      <CheckedConfirmation />
    </RespiratorySymptomsBase>
  );
};
